// nativeRecorder.js — the proven native-recorder bridge.
//
// On the native iOS/Android wrapper, audio recording is handled NATIVELY (the
// web view posts messages to ReactNativeWebView; the native Expo AV recorder
// captures + uploads). Browser MediaRecorder is unreliable in iOS WKWebView,
// so anything that records must route through here when running natively.
//
// These helpers mirror src/api/Recorder.js (the classic recorder) exactly so
// MultiRecord++ speaks the identical protocol.

// Post a message to the native recorder host.
export const sendNativeMessage = (type, value = {}) => {
  const message = { type, value };
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
    return;
  }
  // Cross-origin iframe (CX embed): ReactNativeWebView isn't in the iframe —
  // relay to the parent (loader.js) which forwards to the native host.
  try {
    if (
      window.parent &&
      window.parent !== window &&
      window.parent.postMessage
    ) {
      window.parent.postMessage({ __compNativeRelay: true, message }, '*');
    }
  } catch (e) {
    // no reachable parent
  }
};

// 'ios' | 'android' | '' — read from the comp_platform URL param (works in the
// CX embed iframe) and cached in sessionStorage. Empty when a plain web app.
export const getRecorderPlatform = () => {
  try {
    const href = String(
      window.location && window.location.href ? window.location.href : '',
    );
    const m = href.match(/(?:[?#&])comp_platform=([^&#]+)/);
    const fromQuery = m && m[1] ? decodeURIComponent(m[1]) : null;
    if (fromQuery && fromQuery !== '') {
      sessionStorage.setItem('platform', fromQuery);
      return fromQuery;
    }
    return sessionStorage.getItem('platform') || '';
  } catch (e) {
    return '';
  }
};

// True when recording must go through the native host (iOS/Android wrapper).
export const isNativeRecorder = () => {
  const p = getRecorderPlatform();
  return p === 'ios' || p === 'android';
};
